var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPng = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BF55ED",
  fillRule: "evenodd",
  d: "M9 0h7l6 6v15a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16 0v4a2 2 0 0 0 2 2h4z",
  opacity: 0.6
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 8,
  x: 2,
  y: 13,
  fill: "#F7F8FA",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#BF55ED",
  d: "M4 18.947v-3.894h1.606q.436 0 .754.171.318.169.491.474.173.302.173.703 0 .403-.177.706-.174.3-.499.465-.324.166-.77.166h-.991v-.742h.816q.213 0 .355-.074a.5.5 0 0 0 .218-.207.64.64 0 0 0 .074-.314.6.6 0 0 0-.074-.312.5.5 0 0 0-.218-.205.8.8 0 0 0-.355-.072H4.94v3.135zM11.33 15.053v3.894h-.797L8.986 16.7h-.025v2.247h-.94v-3.894h.81l1.53 2.244h.032v-2.244zM15.007 16.325a.7.7 0 0 0-.095-.21.6.6 0 0 0-.362-.256 1 1 0 0 0-.259-.034.87.87 0 0 0-.49.137.9.9 0 0 0-.316.4 1.6 1.6 0 0 0-.112.632q0 .375.108.64.108.263.313.402a.87.87 0 0 0 .497.139q.259 0 .437-.084a.6.6 0 0 0 .274-.241.7.7 0 0 0 .092-.367l.175.02h-.945v-.686H16v.516q0 .522-.222.895-.22.374-.608.572a1.9 1.9 0 0 1-.886.2q-.556 0-.978-.241t-.656-.689q-.236-.449-.236-1.064 0-.48.143-.85.142-.372.396-.631.257-.259.593-.392.337-.133.727-.133.337 0 .628.097.293.097.516.274.226.177.367.42t.174.534z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPng);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;